import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web/common/consts/ISO_TO_COUNTRY_NAME";
import { useStrictLocalization } from "@faire/web/common/localization";
export var useCountryName = function useCountryName(countryISO) {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  return ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[countryISO];
};